
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./SearchBar.css";

const SearchBar = ({ searchTitle, setSearchTitle }) => {
  return (
    <div>
      <Input
        placeholder="Pretraži po naslovu"
        value={searchTitle}
        onChange={(e) => setSearchTitle(e.target.value)}
       className="searchbar-input"
        prefix={
          <SearchOutlined
            style={{
              position: "absolute",
              left: 15,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#888",
              fontSize: "18px",
            }}
          />
        }
      />
    </div>
  );
};
export default SearchBar;
